import moment from "moment";
import axios from "axios";

export const appMixin = {
    methods: {
        /**
         * Define global functions and properties here
         *
         */
        moment(date) {
            return moment(date).utc();
        },
        dataTimeFormat(date, format) {
            return moment(date).utc().format(format);
        },
        // Prepare moment without UTC
        momentWithoutUTC(date) {
            return moment(date);
        },
        // Prepare data time format without UTC
        dataTimeFormatWithoutUTC(date, format) {
            return moment(date).format(format);
        },
        truncateString(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            }
            return str;
        },
        async getUserProfile() {
            const response = await axios.post('/api/user');
            return response.data;
        },
        async getSettings() {
            try {
                const response = await axios.post('/api/settings');
                return response.data;
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        },
    }
}
